module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clum2right left"
  }, [_c('div', {
    staticClass: "left",
    attrs: {
      "id": "content_block"
    }
  }, [_c('div', {
    staticClass: "account_icon left"
  }), _vm._v(" "), _c('div', {
    staticClass: "content_title left"
  }, [_vm._v("My Profile > Change Password")]), _vm._v(" "), _c('div', {
    staticClass: "left",
    attrs: {
      "id": "content_main"
    }
  }, [_c('div', {
    staticClass: "pure-form pure-form-aligned"
  }, [_c('fieldset', [_c('div', {
    staticClass: "pure-control-group",
    staticStyle: {
      "line-height": "50px"
    }
  }, [_c('label', {
    attrs: {
      "for": "newpsw"
    }
  }, [_vm._v("Reset Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newpsw),
      expression: "newpsw"
    }],
    staticClass: "pure-input-2-3",
    attrs: {
      "id": "newpsw",
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.newpsw)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newpsw = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pure-control-group",
    staticStyle: {
      "line-height": "50px"
    }
  }, [_c('label', {
    attrs: {
      "for": "confirmPsw"
    }
  }, [_vm._v("Confirm Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmpsw),
      expression: "confirmpsw"
    }],
    staticClass: "pure-input-2-3",
    attrs: {
      "id": "confirmPsw",
      "type": "password",
      "placeholder": "Confirm Password"
    },
    domProps: {
      "value": (_vm.confirmpsw)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmpsw = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pure-controls",
    staticStyle: {
      "margin-left": "170px"
    }
  }, [_c('button', {
    staticClass: "button-warning pure-button pure-button-primary",
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "type": "reset",
      "value": "Reset"
    },
    on: {
      "click": function($event) {
        _vm.cancel()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "button-warning pure-button pure-button-primary",
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.clicksave()
      }
    }
  }, [_vm._v("Save")])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-488b55da!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/private/pages/Changepsw.vue
// module id = 107
// module chunks = 1